"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassroomModel = void 0;
var Model_1 = __importDefault(require("../Model"));
// import i18n from '../i18n';
var math_1 = require("../../helpers/math");
var User_1 = require("../User");
var array_1 = require("../../helpers/array");
var ClassroomModel = /** @class */ (function (_super) {
    __extends(ClassroomModel, _super);
    function ClassroomModel(classroom, getters) {
        var _this = _super.call(this, getters) || this;
        _this.boardsClassroomsByClassroomId = classroom.boardsClassroomsByClassroomId || [];
        _this.enrollmentsByClassroomId = classroom.enrollmentsByClassroomId || [];
        _this.id = classroom.id;
        _this.name = classroom.name;
        _this.slug = classroom.slug;
        _this.isBonus = classroom.isBonus;
        _this.type = classroom.type || 'default';
        _this.progress = _this.getProgress(classroom.progress);
        _this.courseId = classroom.courseId || null;
        _this.appointmentIds = classroom.appointmentIds || [];
        _this.staffByClassroomId = classroom.staffByClassroomId || [];
        _this.stoppedLists = classroom.stoppedLists || [];
        _this.popularLists = classroom.popularLists || [];
        _this.associatedLists = classroom.associatedLists || [];
        _this.materialsByClassroomId = classroom.materialsByClassroomId || [];
        return _this;
    }
    ClassroomModel.prototype.getProgress = function (progress) {
        var _a, _b;
        var classroomProgress = (_b = (_a = this.getters) === null || _a === void 0 ? void 0 : _a.classroomProgressById) === null || _b === void 0 ? void 0 : _b.call(_a, this.id);
        if (typeof classroomProgress === 'number')
            return math_1.progressFormat(classroomProgress);
        if (progress)
            return math_1.progressFormat(progress);
        return 0;
    };
    Object.defineProperty(ClassroomModel.prototype, "studentsIds", {
        get: function () {
            return this.getters.studentIdsByClassroom(this.id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClassroomModel.prototype, "workload", {
        get: function () {
            return this.boards.reduce(function (acc, board) { return acc + board.workload; }, 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClassroomModel.prototype, "syllabus", {
        get: function () {
            return this.boards.reduce(function (acc, board) { return acc.concat(board.syllabus); }, '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClassroomModel.prototype, "objectives", {
        get: function () {
            return this.boards.reduce(function (acc, board) { return acc.concat(board.objectives); }, '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClassroomModel.prototype, "programmaticContent", {
        get: function () {
            var knowledges = this.boards.reduce(function (acc, board) {
                return acc.concat(board
                    .knowledgesByType()
                    .programmaticContent.filter(function (content) { return !!content && !!content.name; })
                    .map(function (content) { return content.name; }));
            }, []);
            return knowledges;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClassroomModel.prototype, "methodology", {
        get: function () {
            return this.boards.reduce(function (acc, board) { return acc.concat(board.methodology); }, '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClassroomModel.prototype, "readings", {
        get: function () {
            return this.boards.reduce(function (acc, board) { return acc.concat(board.readings); }, []);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClassroomModel.prototype, "boards", {
        get: function () {
            var _this = this;
            return this.boardsClassroomsByClassroomId.map(function (boardsClassroomId) { return _this.getters.boardsClassroomById(boardsClassroomId).board; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClassroomModel.prototype, "boardTeachers", {
        get: function () {
            var teachers = this.boards.map(function (board) { return board.teachers; });
            return teachers.reduce(function (acc, teacher) { return acc.concat(teacher); }, []);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClassroomModel.prototype, "boardsClassrooms", {
        get: function () {
            var _this = this;
            return this.boardsClassroomsByClassroomId.map(function (boardsClassroomId) {
                return _this.getters.boardsClassroomById(boardsClassroomId);
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClassroomModel.prototype, "studyCase", {
        get: function () {
            var studyCases = this.boards.reduce(function (acc, board) {
                if (board.studyCase)
                    acc.push(board.studyCase);
                return acc;
            }, []);
            return studyCases.length ? studyCases[0] : {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClassroomModel.prototype, "degree", {
        get: function () {
            var currentCourse = this.getters.currentCourse;
            var boardsDegrees = this.boards.reduce(function (acc, board) { return acc.concat(board.boardsDegrees); }, []);
            if (!boardsDegrees || boardsDegrees.length === 0)
                return;
            var courseDegrees = boardsDegrees.filter(function (boardDegree) { return boardDegree.degree.courseId === currentCourse.id; });
            if (!courseDegrees || courseDegrees.length === 0)
                return;
            return courseDegrees[0].degree && courseDegrees[0].degree.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClassroomModel.prototype, "teachers", {
        get: function () {
            var _this = this;
            var staffs = this.staffByClassroomId.map(function (staffId) { return _this.getters.staffById(staffId); });
            return staffs.reduce(function (teachers, staff) {
                if (staff.user instanceof User_1.UserModel)
                    teachers.push(staff.user);
                return teachers;
            }, []);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClassroomModel.prototype, "plan", {
        get: function () {
            var teachers = this.boardTeachers;
            var teacherLabel = teachers.length
                ? {
                    label: /* i18n.tc('teacher', teachers.length) */ 'Professor(es)',
                    text: teachers.filter(function (teacher) { return !!teacher && !!teacher.name; }).map(function (teacher) { return teacher.name; }),
                    src: teachers.filter(function (teacher) { return !!teacher && !!teacher.avatarUrl; }).map(function (teacher) { return teacher.avatarUrl; }),
                    teachers: teachers,
                }
                : {};
            var workload = this.workload;
            var workloadLabel = workload ? { label: /* i18n.tc('workload') */ 'Carga horária', text: workload + "h" } : {};
            var readings = this.readings;
            var readingsLabel = readings.length
                ? {
                    label: /* i18n.tc('bibliography') */ 'Bibliografia',
                    text: readings.filter(function (reading) { return !!reading && !!reading.name; }).map(function (reading) { return reading.name; }),
                }
                : {};
            var syllabus = this.syllabus;
            var syllabusLabel = syllabus.length
                ? {
                    label: /* i18n.tc('syllabus') */ 'Ementa',
                    text: syllabus,
                }
                : {};
            var objectives = this.objectives;
            var objectivesLabel = objectives.length
                ? {
                    label: /* i18n.tc('objectives') */ 'Objetivos',
                    text: objectives,
                }
                : {};
            var programmaticContent = this.programmaticContent;
            var programmaticContentLabel = programmaticContent.length
                ? {
                    label: /* i18n.tc('programmaticContent') */ 'Conteúdos',
                    text: programmaticContent,
                }
                : {};
            var methodology = this.methodology;
            var methodologyLabel = methodology.length
                ? {
                    label: /* i18n.tc('methodology') */ 'Metodologia de Ensino',
                    text: methodology,
                }
                : {};
            return [
                teacherLabel,
                workloadLabel,
                syllabusLabel,
                objectivesLabel,
                programmaticContentLabel,
                methodologyLabel,
                readingsLabel,
            ];
        },
        enumerable: false,
        configurable: true
    });
    ClassroomModel.prototype.getLists = function () {
        return this.boards.reduce(function (acc, board) { return acc.concat(board.lists); }, []);
    };
    ClassroomModel.prototype.getPopularLists = function () {
        var _this = this;
        return this.popularLists.map(function (listId) { return _this.getters.listById(listId); });
    };
    ClassroomModel.prototype.getStoppedLists = function () {
        var _this = this;
        return this.stoppedLists.map(function (listId) { return _this.getters.listById(listId); });
    };
    ClassroomModel.prototype.getAssociatedLists = function () {
        var _this = this;
        return this.associatedLists.map(function (listId) { return _this.getters.listById(listId); });
    };
    Object.defineProperty(ClassroomModel.prototype, "tags", {
        get: function () {
            return this.boards.reduce(function (acc, board) {
                return acc.concat(board
                    .knowledgesByType()
                    .degreeKnowledge.filter(function (degreeKnowledge) { return !!degreeKnowledge && !!degreeKnowledge.name; })
                    .map(function (degreeKnowledge) { return degreeKnowledge.name; }));
            }, []);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClassroomModel.prototype, "appointments", {
        get: function () {
            var appointments = this.getters.appointmentByClassroomId(this.id);
            return appointments.filter(function (appointment) { return !!appointment.event; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClassroomModel.prototype, "providerAssociations", {
        get: function () {
            return this.getters.providerAssociationsByClassroomId(this.id);
        },
        enumerable: false,
        configurable: true
    });
    ClassroomModel.prototype.isComplementary = function () {
        return this.type === 'complementary';
    };
    ClassroomModel.prototype.isLeveling = function () {
        return this.type === 'leveling';
    };
    Object.defineProperty(ClassroomModel.prototype, "materials", {
        get: function () {
            var _this = this;
            return this.materialsByClassroomId.map(function (materialId) { return _this.getters.materialById(materialId); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClassroomModel.prototype, "revisionLists", {
        get: function () {
            return this.materials
                .concat()
                .sort(array_1.positionAscending)
                .reduce(function (acc, material) {
                if (material.list)
                    acc.push(material.list);
                return acc;
            }, []);
        },
        enumerable: false,
        configurable: true
    });
    return ClassroomModel;
}(Model_1.default));
exports.ClassroomModel = ClassroomModel;
